import { useMediaQuery, useTheme } from '@mui/material';
import { FC, memo } from 'react';

import { DateTimePickerDesktop } from './DateTimePickerDesktop';
import { DateTimePickerMobile } from './DateTimePickerMobile';
import { DateTimePickerProperties } from './types';

const DateTimePickerComponent: FC<DateTimePickerProperties> = (props) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  if (isMobile) {
    return <DateTimePickerMobile {...props} />;
  }

  return <DateTimePickerDesktop {...props} />;
};

function areEqual(
  prevProps: DateTimePickerProperties,
  nextProps: DateTimePickerProperties,
) {
  return (
    prevProps.isOpen === nextProps.isOpen &&
    prevProps.anchorRef.current === nextProps.anchorRef.current &&
    JSON.stringify(prevProps.initialDraftState) ===
      JSON.stringify(nextProps.initialDraftState)
  );
}

export const DateTimePicker = memo(DateTimePickerComponent, areEqual);
